import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import * as moment from 'moment';

export class DateHelper {
    public static toDateString(date: Date, dateFormat: string = 'YYYY-DD-MM'): string {
        if (date === null) {
            return "";
        }

        return moment(date).format(dateFormat);
    }

    public static addDays(date: Date, numberOfDays: number = 1): Date | undefined {
        if (date === null) {
            return null;
        }

        date.setDate(date.getDate() + numberOfDays);
        return date;
    }

    public static toNgbDate(date: Date): NgbDateStruct {
        const ngbDate: NgbDateStruct = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
        return ngbDate;
    }

    public static isDateValid(date: NgbDateStruct): any {
        var toDate = new Date(date.year, date.month - 1, date.day).toString()
        return !toDate.includes("Invalid")
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/dateHelper.ts